import {useState } from "react";
import Templates from '../../templates/Templates.tsx';
import companiesData from '../../utils/companiesUtilities.js';
import './design.css';

let body = '';
let sdata = '';
let cmbidx = 0;
let subject = '';
let userName = '';
let userPhone= '';
let rsubject = 'Solicitud de Producto ';
let renderEmail = new Templates();

const OrdersForm = ({companyId, companiName}) => {
  const [message, setMessage] = useState("");

  const handleChangeName = (event) => {
    setMessage(event.target.value);
    userName = event.target.value;
  };

  const handleChangePhone = (event) => {
    setMessage(event.target.value);
    userPhone = event.target.value;
  };

  const handleChangeSubject = (event) => {
    setMessage(event.target.value);
    body = event.target.value;
    sdata = document.getElementById("cmb1").selectedOptions[0];
    cmbidx = parseInt(event.target.selectedIndex);
  };

  //Getting Data.
  companyId = (companyId != null) ?  parseInt(companyId) : 1;
  companiName = (companiName != null) ?  companiName : "N/A";
  let companyData = new companiesData().GetDataCmb(companyId);
  let mailto = new companiesData().GetMailTo(companyId, cmbidx);

  if (sdata != null) {
    subject = rsubject + " - " + sdata.text;
    renderEmail = new Templates(mailto, subject, body, userName, userPhone, companiName);
  }


  return (
    <div className="serviceForm">
      <h3 className="contain-header">SOLICITUD DE SERVICIO</h3>

      <div>
        <form method="post" action={renderEmail.Orders()}>
          <table className="serviceFormTable">
            <tr>
              <td>
                <label for="tb1">Nombre</label>
              </td>
              <td>
                <input
                  id="tb1"
                  type="text"
                  minLength={8}
                  onChange={handleChangeName}
                  required
                />
              </td>
            </tr>
            <tr>
              <td>
                <label for="tb2">Teléfono</label>
              </td>
              <td>
                <input
                  id="tb2"
                  type="number"
                  pattern="\d*"
                  min="8090000000"
                  max="8300000000"
                  onChange={handleChangePhone}
                  required
                />
              </td>
            </tr>
            <tr>
              <td>
                <label for="cmb1">Tipo Servicio</label>
              </td>
              <td>
                <select id="cmb1" onChange={handleChangeSubject} required>
                  <option value="">Seleccione un Servicio</option>

                  {companyData.map((service, index) => {
                    return (
                      <option value={service.value}>{service.display}</option>
                    );
                  })}
                </select>
              </td>
            </tr>
            <tr>
              <td colSpan={2} style={{ textAlign: "center" }}>
                <button className="btnServices" type="submit">
                  Enviar
                </button>
              </td>
            </tr>
          </table>
        </form>
      </div>
    </div>
  );
};

export default OrdersForm;